function server() {
  // return "http://localhost/vaigaiclaas/web/";
  // return "https://vaigaiclaas.com/test/api/v1/web/backend/";
  return "https://dev.strackit.com/vaigai/api/v1/web/";
}

export default server;
